import { Clipboard } from '@capacitor/clipboard';

export async function copyStringToClipboard(value: string | number | null | undefined) {
  if (value === null || value === undefined) {
    return;
  }

  const stringValue = typeof value === 'number' ? value.toString() : value;
  await Clipboard.write({ string: stringValue });
}

export async function copyImageToClipboard(value: string | null | undefined) {
  if (value === null || value === undefined) {
    return;
  }

  await Clipboard.write({ image: value });
}

export async function copyUrlToClipboard(value: string | null | undefined) {
  if (value === null || value === undefined) {
    return;
  }

  await Clipboard.write({ url: value });
}
